import $ from 'jquery';

$('button.dashboard-list__summary').on('click', event => {
  const group = event.currentTarget.closest('.dashboard-list__group');

  $('.dashboard-list__icon-group', event.currentTarget)
    .toggleClass('dashboard-list__icon-group--collapsed');
  $('.dashboard-list__details', group).slideToggle(200);
});
